import { render } from "./Algorithm.vue?vue&type=template&id=c76aee2c&scoped=true&bindings={}"
import script from "./Algorithm.vue?vue&type=script&lang=ts"
export * from "./Algorithm.vue?vue&type=script&lang=ts"

import "./Algorithm.vue?vue&type=style&index=0&id=c76aee2c&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-c76aee2c"

export default script